import { Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import styles from "./styles.module.css";
import { FunctionComponent, useContext } from "react";

interface CabecalhoProps {
  title: string;
  icon: "document" | "group" | "hands" | "bank";
}

const Cabecalho: FunctionComponent<CabecalhoProps> = ({ title, icon}) => {
  let icone = estiloIcone(icon);
  const { name } = useContext(UserContext);
  return (
    <header className={styles.cabecalho}>
      <h3 className={icone}>{title}</h3>
      <div>
        <span>{name}</span>
      </div>
    </header>
  );
};

export default Cabecalho;

function estiloIcone(icon: string) {
  let icone: string;
  switch (icon) {
    case "document":
      icone = styles.document;
      break;
    case "group":
      icone = styles.group;
      break;
    case "hands":
      icone = styles.hands;
      break;
    case "bank":
      icone = styles.bank;
      break;
    default:
      icone = "";
      break;
  }

  return icone;
}
